/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T17:06:23+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-29T17:55:31+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ALabelInput from './ALabelInput';
import ATextInputDescription from './ATextInputDescription';
import AButtonIconHelp from 'common/buttons/components/AButtonIconHelp';

/**
 * MLabelInput - …
**/
class MLabelInput extends Component {
  render() {
    const {
      htmlFor,
      label,
      description,
      toolLabel,
      toolIcon,
      onPressTool,
      disabled,
      ...other
    } = this.props;

    let toolButtonEl;

    const descriptionEl = (!description) ? null
            : (<ATextInputDescription>{description}</ATextInputDescription>);

    const disabledClass = (disabled) ? 'disabled' : '';

    if (toolLabel || toolIcon || onPressTool) {
      toolButtonEl = (
        <AButtonIconHelp
          label={toolLabel}
          icon={toolIcon}
          onPress={onPressTool}
        />
      );
    }

    return (
      <div
        {...other}
        className={`m-label m-label-input ${disabledClass}`}
      >
        <ALabelInput
          htmlFor={htmlFor}
        >{label}</ALabelInput>
        {toolButtonEl}
        {descriptionEl}
      </div>
    );
  }
}
MLabelInput.propTypes = {
  /**
     * name of the input the label is for
     */
  htmlFor: PropTypes.string,
  /**
     * label and children are the same
     */
  label: PropTypes.string,
  /**
     * description for the input
     */
  description: PropTypes.any,
  /**
     * label for the tool-button, like 'Help'
     */
  toolLabel: PropTypes.string,
  /**
     * icon for the tool button like 'question-sign'
     */
  toolIcon: PropTypes.string,
  /**
     * displays a tool button with icon and fires
     * whe it is pressed. useful to show extra help infos
     */
  onPressTool: PropTypes.func,
  /**
     * show disable state of header
     */
  disabled: PropTypes.bool,
};
MLabelInput.defaultProps = {};
export default MLabelInput;

